import React from 'react';
import PropTypes from 'prop-types';
import Layout from "../layout";
import OAuthLogin from "./oauth-list";
var Connect = function Connect(props) {
  // <OAuthLogin setLoading={setLoading} event={event} />
  return /*#__PURE__*/React.createElement(Layout, {
    login: OAuthLogin
  });
};
Connect.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number
};
Connect.defaultProps = {
  elements: [],
  index: null
};
export default Connect;